import styled from 'styled-components'

export const PopUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const PopUpHeader = styled.div`
  background-color: #0066B3;
  height: 53px;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  flex-shrink: 0;
`

export const PopUpTitle = styled.h4`
  color: #fff;
  font-size: 20px;
  margin: 0;
`

export const PopUpContent = styled.div`
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 32px;
`

export const PopUpParagraph = styled.span`
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  color: #464646;
  width: 100%;
  text-align: center;
  display: block;
  overflow: hidden;
`
